// extracted by mini-css-extract-plugin
export default {"container":"RB-z","dimension":"SB-z","dimensionLabels":"TB-z"};